module.exports = __webpack_public_path__ + "img/deck_no_roof.7e83365a.jpg";